import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../shared/api/apiSlice';
import { userSlice } from './userSlice';
import { modalSlice } from './modalSlice';
import { cartSlice } from './cartSlice';
import { coinsSlice } from './coinsSlice';
import { popupSlice } from './popupSlice';

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    modal: modalSlice.reducer,
    cart: cartSlice.reducer,
    coins: coinsSlice.reducer,
    popup: popupSlice.reducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
